import React from "react";
import { List } from "../modules/LateHistory";

export function LateHistoryPage() {
  return <List />;
}
